// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3sGDH","noInteraction":"EventWrapper_noInteraction__2Eg5Z","pointerPassthrough":"EventWrapper_pointerPassthrough__12C0P"};